<template>
  <!-- Start Footer Area -->
  <footer class="footer-area bg-f7fafd">
    <div class="container">
      <div class="row">
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="single-footer-widget">
            <div class="logo">
              <a href="/"> </a>
            </div>
            <p style="color: white">
              Built with 💗 in Athens (GA) and Beverly Hills (CA) by family for
              family
            </p>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="single-footer-widget pl-lg-5">
            <h3>Tink's Area</h3>
            <ul class="list">
              <li v-if="false">
                About Us
              </li>
              <li v-if="!config.isBeta" @click="handleDiscoverClick">
                Discover MyApps
              </li>
              <li @click="handleBlogClick">
                My Blog
              </li>
              <li @click="handleMemoriesClick">
                Our Memories
              </li>
              <li @click="handleFavesClick">
                Tink's Faves
              </li>
              <li @click="handleCreditsClick">
                Thank You and Photo Shoot
              </li>
              <li v-if="!config.isBeta" @click="handlePricingClick">
                Pricing Plans
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="single-footer-widget pl-lg-5">
            <h3>Support</h3>
            <ul class="list">
              <li @click="handlePolicyClick('privacy')">
                Privacy
              </li>
              <li @click="handlePolicyClick('terms')">
                Terms
              </li>
              <li @click="handlePolicyClick('data')">
                Data
              </li>
            </ul>
          </div>
        </div>
        <div v-if="false" class="col-lg-3 col-md-6 col-sm-6">
          <div class="single-footer-widget">
            <h3>Address</h3>
            <ul class="footer-contact-info">
              <li v-if="false">
                9461 Charleville Blvd. #888
              </li>
              <li v-if="false">Beverly Hills, CA 90212</li>
              <li>
                Email:
                <a href="mailto:hello@d3rriana.com"> hello@d3rriana.com</a>
              </li>
              <li v-if="false">
                Phone:
                <a href="tel:+5595120719">+1 (323) 739-8664</a>
              </li>
            </ul>
            <social-link-share />
          </div>
        </div>
        <div class="col-lg-12 col-md-12">
          <div class="copyright-area">
            <p>Copyright &copy;2024 D3rriana. All Rights Reserved</p>
          </div>
        </div>
      </div>
    </div>

    <img src="@/assets/img/map.png" class="map" alt="map" />
    <back-to-top bottom="50px" right="50px">
      <div class="go-top" />
    </back-to-top>
  </footer>
  <!-- End Footer Area -->
</template>
<script>
import BackToTop from "vue-backtotop";
import config from "@/assets/_config.json";
import SocialLinkShare from "@/components/common/socialLinkShare";

export default {
  name: "Footer",
  components: {
    BackToTop,
    SocialLinkShare
  },
  data() {
    return {
      config
    };
  },
  methods: {
    handleDiscoverClick() {
      this.$router.push("/myapps");
    },
    handleBlogClick() {
      this.$router.push("/blog");
    },
    handleMemoriesClick() {
      this.$router.push("/memories");
    },
    handleFavesClick() {
      this.$router.push("/faves");
    },
    handleCreditsClick() {
      this.$router.push("/thankyou");
    },
    handlePricingClick() {
      this.$router.push("/pricing");
    },
    handlePolicyClick(policyType) {
      this.$router.push(`/policy/${policyType}`);
    }
  }
};
</script>

<style lang="scss" scoped>
.footer-area {
  position: relative;
  z-index: 1;
  padding-top: 80px;
  background-color: #222222;
}

.footer-area .map {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  text-align: center;
  z-index: -1;
  bottom: 0;
  opacity: 0.7;
}

.single-footer-widget .logo {
  margin-bottom: 20px;
}

.single-footer-widget .logo a {
  display: block;
}

.single-footer-widget h3 {
  font-size: 18px;
  margin-bottom: 30px;
  color: #fe828c;
}

.single-footer-widget ul {
  padding: 0;
  margin: 0;
  list-style-type: none;
  color: #f3f5f6;
}

.single-footer-widget ul.list li {
  margin-bottom: 10px;
  cursor: pointer;
}

.single-footer-widget ul.list li a {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}

.single-footer-widget ul.list li a:hover {
  color: #557efb;
  padding-left: 7px;
}

.single-footer-widget ul.list li:last-child {
  margin-bottom: 0;
}

.single-footer-widget ul.footer-contact-info {
  margin-bottom: 20px;
}

.single-footer-widget ul.footer-contact-info li {
  position: relative;
  color: #ffffff;
  margin-bottom: 8px;
}

.single-footer-widget ul.footer-contact-info li i {
  position: absolute;
  left: 0;
  width: 15px;
  top: 5px;
}

.single-footer-widget ul.footer-contact-info li:last-child {
  margin-bottom: 0;
}

.single-footer-widget ul.footer-contact-info li a {
  color: #ffffff;
}

.single-footer-widget ul.footer-contact-info li a:hover {
  color: #557efb;
}

.copyright-area {
  margin-top: 80px;
  padding-top: 25px;
  padding-bottom: 25px;
  border-top: 1px solid #d8ebfd;
  text-align: center;
  color: white;
}
@media (max-width: 640px) {
  .single-footer-widget h3 {
    margin-bottom: 12px;
    margin-top: 20px;
  }
}
</style>
